import React, { useState, useEffect } from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useTranslation } from "react-i18next";

const UserFilter = ({
  selectedUser,
  setSelectedUser,
  usersList = [],
  setDebouncedInputUserValue,
  isUsersLoading,
  style,
  size,
  isError,
  externalLabel,
  externalPlaceholder,
  externalNegativeLabel,
  isRequired = false,
  setPage = () => {},
  startAdornment = (
    <>
      <SearchRoundedIcon size={20} />
    </>
  ),
  ...props
}) => {
  const { t } = useTranslation();
  const PLACE_HOLDER_EXTENDED = externalPlaceholder
    ? externalPlaceholder
    : t("ExtSearchUser");
  const PLACE_HOLDER = externalLabel ? externalLabel : t("BriefSearchUser");
  const [inputUserValue, setInputUserValue] = useState("");
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedInputUserValue(inputUserValue);
    }, 750);
    return () => {
      clearTimeout(timer);
    };
  }, [inputUserValue, setDebouncedInputUserValue]);

  return (
    <Autocomplete
      {...props}
      loading={isUsersLoading}
      loadingText={t("Loading...")}
      id="combo-box-demo"
      size={size ? "" : "small"}
      className="w-full"
      value={selectedUser}
      onChange={(event, userObject) => {
        userObject ? setSelectedUser(userObject) : setSelectedUser(undefined);
        setPage({
          currentPage: 1,
          startRow: 0,
          endRow: TABLE_ROWS_NUMBER,
        });
      }}
      inputValue={inputUserValue}
      onInputChange={(event, newInputValue) => {
        setInputUserValue(newInputValue);
      }}
      options={usersList?.map((user) => ({
        ...user,
        label: user?.name + " " + user?.surname,
      }))}
      noOptionsText={externalNegativeLabel || t("NoUserFound")}
      filterOptions={(options, { inputValue }) => {
        return options?.filter(
          (item) =>
            item?.name?.toLowerCase().includes(inputValue.toLowerCase()) ||
            item?.surname?.toLowerCase().includes(inputValue.toLowerCase()) ||
            item?.email?.toLowerCase().includes(inputValue.toLowerCase()) ||
            item?.fiscalCode?.toLowerCase().includes(inputValue.toLowerCase())
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          error={isError}
          required={isRequired}
          style={style}
          label={PLACE_HOLDER}
          placeholder={PLACE_HOLDER_EXTENDED}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isUsersLoading ? (
                  <CircularProgress style={{ color: colorPrimary }} size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
            startAdornment: startAdornment,
          }}
        />
      )}
    />
  );
};

export default UserFilter;
